var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00033 15.6667C12.6822 15.6667 15.667 12.682 15.667 9.00008C15.667 5.31818 12.6822 2.33341 9.00033 2.33341C5.31843 2.33341 2.33366 5.31818 2.33366 9.00008C2.33366 12.682 5.31843 15.6667 9.00033 15.6667ZM9.00033 17.3334C13.6027 17.3334 17.3337 13.6025 17.3337 9.00008C17.3337 4.39771 13.6027 0.666748 9.00033 0.666748C4.39795 0.666748 0.666992 4.39771 0.666992 9.00008C0.666992 13.6025 4.39795 17.3334 9.00033 17.3334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleUnchecked);
export default __webpack_public_path__ + "static/media/Circle-Unchecked.aea9376cede7d7454514e16e2ec98565.svg";
export { ForwardRef as ReactComponent };